import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OcrData } from '../../models/ocr-model';
import { ApiService } from '@ps-gui/shared-core';

@Injectable({
  providedIn: 'root',
})
export class PageDataApiService extends ApiService {
  protected override get baseUrl(): string {
    return this.backendUrls.ctBackendUrl;
  }

  getOcrForPage(pageId: string): Observable<OcrData> {
    return this.get(`api/page/${pageId}/ocr`);
  }
}
